document.addEventListener("DOMContentLoaded", function () {

  // Se NON c'è il meta tag, esci
  var meta = document.querySelector("meta[name='chiusurextra']");
  if (!meta) return;

  var addToCartButton = document.querySelector("button[name='add']");
  if (!addToCartButton) return;

  var wrapper = document.createElement("div");
  wrapper.style.margin = "12px 0";
  wrapper.style.padding = "10px";
  wrapper.style.border = "1px solid #ddd";
  wrapper.style.borderRadius = "12px";

  var title = document.createElement("div");
  title.innerText = "Vuoi una chiusura extra?";
  title.style.marginBottom = "10px";
  title.style.fontWeight = "bold";
  wrapper.appendChild(title);

  var row = document.createElement("div");
  row.style.display = "flex";
  row.style.gap = "10px";

  var btn1 = document.createElement("a");
  btn1.href = "/products/chiusura-regolabile";
  btn1.innerText = "Chiusura regolabile";
  btn1.style.padding = "10px 12px";
  btn1.style.border = "1px solid #000";
  btn1.style.borderRadius = "8px";
  btn1.style.textDecoration = "none";
  btn1.style.color = "#000";
  row.appendChild(btn1);

  var btn2 = document.createElement("a");
  btn2.href = "/products/chiusura-con-perlina";
  btn2.innerText = "Chiusura con perlina";
  btn2.style.padding = "10px 12px";
  btn2.style.border = "1px solid #000";
  btn2.style.borderRadius = "8px";
  btn2.style.textDecoration = "none";
  btn2.style.color = "#000";
  row.appendChild(btn2);

  wrapper.appendChild(row);
  addToCartButton.parentNode.insertBefore(wrapper, addToCartButton);
});